import React, { FunctionComponent, useState } from "react";
import { Collapse } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { CupRecord } from "/src/domain/challenges/ChallengeRatingCup";
import { ChallengeUser } from "/src/domain/challenges/ChallengeUser";
import { theme } from "/src/assets/theme";
import { CupParticipant } from "./CupParticipant";
import { CupParticipantInfo } from "./CupParticipantInfo";

export type CupRecordViewProps = {
    record: CupRecord,
    currentUser?: ChallengeUser
}

export const CupRecordView: FunctionComponent<CupRecordViewProps> = ({ record, currentUser }) => {
    const [isExpanded, expand] = useState(false);
    const classes = useStyles();

    return (
        <div onClick={() => { expand(!isExpanded) }} className={classes.container}>
            <CupParticipant record={record} currentUser={currentUser} isExpanded={isExpanded} />
            <Collapse in={isExpanded}>
                <CupParticipantInfo record={record} />
            </Collapse>
        </div>

    );
}

const useStyles = makeStyles({
    container: {
        color: theme.primaryColor,
        '&:nth-child(even)': {
            backgroundColor: theme.lightPrimaryColor
        },
    }
})

